


























import Vue from "vue";
import { mapGetters } from "vuex";

//Model
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";

export default Vue.extend({
    data() {
        return {
            branch: {},
            createFolder: false,
            dialog: false,
        };
    },
    watch: {
        dialog(value) {
            if (!value) this.branch = {};
        },
    },
    computed: {
        ...mapGetters(["authUserHasPrivilege"]),

        createFolderEnabled() {
            return this.authUserHasPrivilege(ClientPrivileges.DevicesManagement);
        },
    },
    methods: {
        reset() {
            this.branch = {};
            this.createFolder = false;
        },
        onSave() {
            this.$emit("add", { branch: this.branch, createFolder: this.createFolder });
            this.dialog = false;
            this.reset();
        },
        onClose() {
            this.dialog = false;
            this.reset();
        },
    },
});
